const environment = import.meta.env.VITE_APP_ENVIRONMENT || "development";

export const isProduction = environment === "production";
export const isStaging = environment === "staging";
export const isDevelopment = environment === "development";
export const SHORT_ENVIRONMENT = isProduction
	? ""
	: environment.slice(0, 3) + " ";
export const ENVIRONMENT = environment;
